import { Address } from 'viem';

import { api, cacheTags, IConnectedActionParams } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import {
  getCommissionInfo,
  IGetCommissionInfo,
} from 'modules/ownerPanel/methods/getCommissionInfo';

interface IGetCommissionArgs extends IConnectedActionParams {
  poolAddress: Address;
}

export const { useGetCommissionInfoQuery } = api.injectEndpoints({
  endpoints: build => ({
    getCommissionInfo: build.query<IGetCommissionInfo, IGetCommissionArgs>({
      queryFn: async ({ poolAddress }) => {
        const client = getPublicClient();

        return {
          data: await getCommissionInfo(client, poolAddress),
        };
      },
      providesTags: [cacheTags.pools, cacheTags.account],
    }),
  }),
});
